import { Button, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

/** Continuing with a declared platform whose seller connection is unavailable. */
export const ConnectLaterExit = ({ onLater }: { onLater: () => void }) => {
  const { t } = useTranslation();

  return (
    <>
      <Button
        variant="outline"
        w="full"
        h="48px"
        mt="10px"
        borderRadius="full"
        bg="white"
        borderColor="border.emphasized"
        color="ink"
        fontFamily="heading"
        fontSize="14px"
        fontWeight="600"
        _hover={{ bg: 'softCream' }}
        onClick={onLater}
      >
        {t('onboarding.connect.later')}
      </Button>
      <Text fontSize="12px" color="inkSubtle" textAlign="center" mt="12px">
        {t('onboarding.connect.laterHelp')}
      </Text>
    </>
  );
};
